module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACjSURBVHgB7ZUxDsIwDEX9Q5EquuQoHKEzMHCEjHTjCpygjGz0BmyscBSOkAllQDZJJSQkOlFLXfKGxP6WnrwZpEC9F1s92YkRfz0VXcoMKVAFammGFjDndcM3NTFB3FdX64kHyOIszuIsnlRcpGfT8IUJS/ob+RWvdi8X4y0GhmMwYFjSxffi+cJ08X+QDlEqh1Tgk6SDaEMYtb0vS38/ot/4DcYSJva8p+sFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-4.png
// module id = IMng
// module chunks = 1